module.exports = __webpack_public_path__ + "img/video-player/up@2x-9eceb438b7d1971ad92b112ab3d10fce.png";